import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import PvOrganization from "../PartialView/PV_Organization.js";
import PvDepartment from "../PartialView/PV_Department.js";
import PvOverview from "../PartialView/PV_Overview.js";
import PVStaff from "../PartialView/PV_Staff.js";
import PVTask from "../PartialView/PV_Task.js";
import PVPositionDaily from "../PartialView/PV_Position_Daily.js";
import PVTransaction from "../PartialView/PV_Transaction.js";
import PVTimesheetbyperiod from "../PartialView/PV_Timesheetbyperiod.js";
import PVTimesheetbyStaff from "../PartialView/PV_TimesheetbyStaff.js";

import { Class_ETC_Decrypt,
        Class_ETC_SessionTimeOut
 } from "../Class/Class_Etc";
import Pathurl from "../Class/Pathurl.json";
import { Link } from "react-router-dom";
import { CP_CheckPermission } from "../Class/Class_Permission";
/* Create By Kai : 26-JULY-2023 */
/* Update By Krisana : 2024-05-30 
   - เพิ่ม Pro_name เพิ่มเก็บค่า ชื่อ Project

*/
function M_project_view() {
 
 
  //#region permission


  // eslint-disable-next-line
  const [isPermissionview, setIsPermissionview] = useState(false);
  // eslint-disable-next-line
  const [isPermissionOverall, setIsPermissionOverall] = useState(false);
  const [isPermissionCostView, setIsPermissionCostAll] = useState(false);
  
  //#endregion

  //#region declare variable
  const [showOrgTab, setshowOrgTab] = useState(false);
  const [showDepTab, setshowDepTab] = useState(false);
  const [showStaffTab, setshowStaffTab] = useState(false);
  const [showTaskTab, setshowTaskTab] = useState(false);
  const [showPosDailyTab, setshowPosDailyTab] = useState(false);
  const [showTranTab, setshowTranTab] = useState(false);
  const [showTSperiodTab, setshowTSperiodTab] = useState(false);
  const [showTSbyStaffTab, setshowTSbyStaffTab] = useState(false);
  //const navigate = useNavigate();
  const location = useLocation();
  const [pgFromPage, setPgFromPage] = useState("");
  const [pgProid, setPgProid] = useState(-1);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [projectEntity, setProjectEntity] = useState([]);

  const [actiontabtran, setActiontabtran] = useState(0);
  const [actiontabTSbyP, setActiontabTSbyP] = useState(0);
  const [actiontabDept, setActiontabDept] = useState(0);
  const [actiontabstaff, setActiontabstaff] = useState(0);

  

  //#endregion

  //#region __ useEffect __
  useEffect(() => {
    if (isFirst === true) {
      let ckpermission = CP_CheckPermission(
        "main",
        ["projects_view", "projects_overview"],
        false,
        true
      );
      if (ckpermission === true) {
        setIsPermissionview(ckpermission);
        setIsPermissionOverall(
          CP_CheckPermission("main", ["projects_overview"], false, false)
        );
        setIsPermissionCostAll(
          CP_CheckPermission("main", ["timesheet_costs_view"], false, false)
        );

        GetParameter(function () {
          GetConfig();
          if (isLoadedConfigData === true) {
            BindProject(function () {
              setIsLoadProgress(false);
              setIsFirst(false);
            });
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);
  //#endregion

  //#region toggle tab
 


  const toggleFlagOrg = () => {
    setshowOrgTab(true);
  };

  const toggleFlagDep = () => {
    
    setshowDepTab(true);
  };

  const toggleFlagStaff = () => {
    setshowStaffTab(true);
  };

  const toggleFlagTask = () => {
    setshowTaskTab(true);
  };
  const toggleFlagPosDaily = () => {
    setshowPosDailyTab(true);
  };

  const toggleFlagTran = () => {
    setshowTranTab(true);
  };

  const toggleFlagTSperiodTab = () => {
    setshowTSperiodTab(true);
  };

  const toggleFlagTSbyStaffTab = () => {
    setshowTSbyStaffTab(true);
  };
  
  //#endregion

  //#region Function

  //#region Event

  function onclick_overview_status(act){

    document.getElementById("hd_tran_status_action").value = act;
    document.getElementById("vert-tabs-tran-tab").click();
    setActiontabtran((actiontabtran) => actiontabtran + 1);
   
  }

  function onclick_overview_TimesheetCost(Mindate , Maxdate){
    document.getElementById("hd_Tsbp_mindate_action").value = Mindate;
    document.getElementById("hd_Tsbp_maxdate_action").value = Maxdate; 
    document.getElementById("vert-tabs-TSperiod-tab").click();
    setActiontabTSbyP((actiontabTSbyP) => actiontabTSbyP + 1);
    
  }

  function onclick_overview_TimesheetDepartment(){
    document.getElementById("vert-tabs-department-tab").click();
    setActiontabDept((actiontabDept) => actiontabDept + 1);
  }

  function onclick_Organization_staff(pro_dept_id , pro_pos_id , dept_name , position_name){
    document.getElementById("hd_staff_pro_dept_id_action").value = pro_dept_id;
    document.getElementById("hd_staff_dept_name_action").value = dept_name;

    document.getElementById("hd_staff_pro_pos_id_action").value = pro_pos_id;
    document.getElementById("hd_staff_position_name_action").value = position_name;

    document.getElementById("vert-tabs-staff-tab").click();
    setActiontabstaff((actiontabstaff) => actiontabstaff + 1);
  }

  
  //#endregion

  function GetParameter(_callback) {
    let isNullParameter = false;
    let proid = "";
    let fromPage = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        proid = Class_ETC_Decrypt(location.state?.proid.toString());

        fromPage = Class_ETC_Decrypt(location.state?.fromPage.toString());

        if (proid === "") {
          isNullParameter = true;
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      window.location.replace("../" + Pathurl.m_projectSearch);
      if (_callback != null) {
        _callback();
      }
    } else {
      setPgProid(proid);
      setPgFromPage(fromPage);

      if (_callback != null) {
        _callback();
      }
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindProject(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_GetData",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setProjectName(json.pro_name);
          setProjectEntity(json);
          if (_callback != null) {
            _callback();
          }
        } else {
          window.location.replace("../" + Pathurl.m_projectSearch);
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        window.location.replace("../" + Pathurl.m_projectSearch);
      }
    } catch {
      window.location.replace("../" + Pathurl.m_projectSearch);
    }
  }

  //#endregion



  return (
    <>
      <Helmet>
        <title>Project view</title>
      </Helmet>
      {/* Content Wrapper. Contains page content */}
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-11 col-sm-12 col-12">
                <div>
                  <div className="text-center">
                    {" "}
                    <h1> {projectName}</h1>
                  </div>
                  
                </div>
              </div>
              <div className="col-lg-1 col-sm-12 col-12 mb-1">
                  <div className="search-icon float-right ">
                    <Link
                      to={"../" + pgFromPage}
                      className="btn btn-tool"
                      data-toggle="tooltip"
                      title="BACK TO PROJECT LIST"
                    >
                      <i className="fas fa-arrow-left" /> BACK
                    </Link>
                  </div>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                {/* SELECT2 EXAMPLE */}
                <div className="">
                  <div className="card-body p-1 mt-1">
                    <div className="row ">
                      <div className="col-lg-2 col-sm-12 col-12  pl-0 pr-2 m-0">
                        <div className="mt-0">
                        </div>
                        {/* Start Navigation */}
                        <div
                          className="nav flex-column nav-tabs bg-light card card-primary "
                          id="vert-tabs-tab"
                          role="tablist"
                          aria-orientation="vertical"
                        >
                          <a
                            className="nav-link  active"
                            id="vert-tabs-overview-tab"
                            data-toggle="pill"
                            href="#vert-tabs-overview"
                            role="tab"
                            aria-controls="vert-tabs-overview"
                            // aria-selected="true"
                          >
                            <div>
                              <span className="">
                                <i className="fas fa-tachometer-alt"> </i>{" "}
                                Overview
                              </span>
                            </div>
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-org-tab"
                            data-toggle="pill"
                            href="#vert-tabs-org"
                            role="tab"
                            aria-controls="vert-tabs-org"
                            aria-selected="false"
                            onClick={toggleFlagOrg}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Organization
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-department-tab"
                            data-toggle="pill"
                            href="#vert-tabs-department"
                            role="tab"
                            aria-controls="vert-tabs-department"
                            aria-selected="false"
                            onClick={toggleFlagDep}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Department
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-staff-tab"
                            data-toggle="pill"
                            href="#vert-tabs-staff"
                            role="tab"
                            aria-controls="vert-tabs-staff"
                            aria-selected="false"
                            onClick={toggleFlagStaff}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Staffs
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-task-tab"
                            data-toggle="pill"
                            href="#vert-tabs-task"
                            role="tab"
                            aria-controls="vert-tabs-task"
                            aria-selected="false"
                            onClick={toggleFlagTask}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Task
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-cost-tab"
                            data-toggle="pill"
                            href="#vert-tabs-cost"
                            role="tab"
                            aria-controls="vert-tabs-cost"
                            aria-selected="false"
                            onClick={toggleFlagPosDaily}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Position daily
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-tran-tab"
                            data-toggle="pill"
                            href="#vert-tabs-tran"
                            role="tab"
                            aria-controls="vert-tabs-tran"
                            aria-selected="false"
                            onClick={toggleFlagTran}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Transaction
                          </a>
                          <a
                            className="nav-link "
                            id="vert-tabs-TSperiod-tab"
                            data-toggle="pill"
                            href="#vert-tabs-TSperiod"
                            role="tab"
                            aria-controls="vert-tabs-TSperiod"
                            aria-selected="false"
                            onClick={toggleFlagTSperiodTab}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Timesheet by period
                          </a>
                          
                          <a
                            className="nav-link "
                            id="vert-tabs-TSbyStaff-tab"
                            data-toggle="pill"
                            href="#vert-tabs-TSbyStaff"
                            role="tab"
                            aria-controls="vert-tabs-TSbyStaff"
                            aria-selected="false"
                            onClick={toggleFlagTSbyStaffTab}
                          >
                            <i
                              className="fas fa-circle fa-xs align-middle"
                              style={{ fontSize: "0.4rem" }}
                            />{" "}
                            Timesheet by Staff
                          </a>

                        </div>
                        {/* End Navigation */}
                      </div>
                      <div
                        className="col-lg-10 col-sm-12 col-12  p-0 m-0"
                        /*style={{ backgroundColor: "#FFF" }}*/
                      >
                        <div className="tab-content" id="vert-tabs-tabContent">
                          {/* Start Over View */}
                          <div
                            className="tab-pane text-left fade show active"
                            id="vert-tabs-overview"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-overview-tab"
                          >
                            {/* Start Over View Detail */}
                            <PvOverview
                              entity={projectEntity}
                              PermissionCostView={isPermissionCostView}
                              onclick_overview_status={onclick_overview_status}
                              onclick_overview_TimesheetCost={onclick_overview_TimesheetCost}
                              onclick_overview_TimesheetDepartment={onclick_overview_TimesheetDepartment}
                            />
                            {/* End Over View Detail */}
                          </div>
                          {/* End Over View */}
                          {/* Start Organization*/}
                          <div
                            className="tab-pane fade "
                            id="vert-tabs-org"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-org-tab"
                          >
                            {/* DIRECT CHAT */}
                            {/* Start Organization Detail */}
                            {showOrgTab && (
                              <PvOrganization
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                                onclick_Organization_staff={onclick_Organization_staff}
                              />
                            )}

                            {/* End Organization Detail */}
                            {/*/.direct-chat */}
                          </div>
                          {/* End Organization*/}
                          {/* Start Department*/}
                          <div
                            className="tab-pane card fade"
                            id="vert-tabs-department"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-department-tab"
                          >
                            {/* Start Department Detail */}
                            {showDepTab && (
                              <PvDepartment
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                                actiontabDept={actiontabDept}
                              />
                            )}
                            {/* End Department Detail */}
                          </div>
                          {/* End Department*/}
                          {/* Start Staff*/}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-staff"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-staff-tab"
                          >
                            <input id="hd_staff_pro_dept_id_action" type="hidden" ></input>
                            <input id="hd_staff_dept_name_action" type="hidden" ></input>

                            <input id="hd_staff_pro_pos_id_action" type="hidden" ></input>
                            <input id="hd_staff_position_name_action" type="hidden" ></input>
                            {/* Start Staff Detail*/}
                            {showStaffTab && (
                              <PVStaff
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                                actiontabstaff={actiontabstaff}
                              />
                            )}

                            {/* End Staff Detail*/}
                          </div>
                          {/* End Staff*/}
                          {/* Start Task*/}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-task"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-task-tab"
                          >
                            {/* DIRECT CHAT */}
                            {/* Start Task Detail*/}
                            {showTaskTab && (
                              <PVTask
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                              />
                            )}

                            {/* End Task Detail*/}
                            {/*/.direct-chat */}
                          </div>
                          {/* End Task*/}
                          {/* Start Position Daily*/}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-cost"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-cost-tab"
                          >
                            {/* Start Position Daily Detail*/}
                            {showPosDailyTab && (
                              <PVPositionDaily
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                              />
                            )}

                            {/* End Position Daily Detail*/}
                          </div>
                          {/* End Position Daily*/}
                          {/* Start Transaction */}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-tran"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-tran-tab"
                          >
                            <input type="hidden" id="hd_tran_status_action" ></input>
                            {/* Start Transaction*/}
                            {showTranTab && (
                              <PVTransaction
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                                actiontabtran={actiontabtran}
                              />
                            )}
                            {/* End Transaction*/}
                          </div>
                          {/* End Transaction */}
                          {/* Start Timesheet by period */}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-TSperiod"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-TSperiod-tab"
                          >
                            <input type="hidden" id="hd_Tsbp_mindate_action" ></input>
                            <input type="hidden" id="hd_Tsbp_maxdate_action" ></input>
                            {/* Start Timesheet by period*/}
                            {showTSperiodTab && (
                              <PVTimesheetbyperiod
                                entity={projectEntity}
                                PermissionCostView={isPermissionCostView}
                                actiontabTSbyP={actiontabTSbyP}
                              />
                            )}
                            {/* End Timesheet by period*/}
                          </div>
                          {/* End Timesheet by period */}
                          {/* Start Timesheet by staff */}
                          <div
                            className="tab-pane card fade "
                            id="vert-tabs-TSbyStaff"
                            role="tabpanel"
                            aria-labelledby="vert-tabs-TSbyStaff-tab"
                          >
                            {/* Start Timesheet by staff*/}
                            {showTSbyStaffTab && (
                              <PVTimesheetbyStaff
                              isReport={0}
                              Pro_id={projectEntity.pro_id.toString()}
                              Pro_name={projectName}
                              />
                            )}
                            {/* End Timesheet by staff*/}
                          </div>
                          {/* End Timesheet by staff */}

                          
                        </div>
                      </div>
                    </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                </div>
                {/* /.row (main row) */}
              </div>
              {/* /.container-fluid */}
            </div>
            {/* /.container-fluid */}
          </div>
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}

export default M_project_view;
